module.exports = "<!-- Loads either the layout.component.ts or pages/auth.routing.ts -->\r\n<router-outlet></router-outlet>\r\n"